import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSystemLoader from './reducers/system-loader.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SystemLoaderEffects } from './effects/system-loader.effects';
import { SystemLoaderFacade } from './facade/system-loader.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromSystemLoader.systemLoaderFeatureKey, fromSystemLoader.systemLoaderReducer),
    EffectsModule.forFeature([SystemLoaderEffects]),
  ],
  providers: [SystemLoaderFacade]
})
export class SystemLoaderStoreModule { }
